import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'
import type { UseErrorModalReturn } from '@percent/domain/giving'

export type PublishCampaignFailureModalProps = Pick<UseErrorModalReturn, 'isOpen' | 'errorMsg' | 'closeModal'>

export function PublishCampaignFailureModal({ isOpen, errorMsg, closeModal }: PublishCampaignFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={closeModal} aria-labelledby="publish-campaign-failure">
      <AcknowledgeModal
        result="negative"
        title={t('workplace_giving.myCampaigns.actions.publishErrorModal.title')}
        description={errorMsg}
        buttonText={t('workplace_giving.common.close')}
        handleClose={closeModal}
      />
    </Modal>
  )
}
